import axios from "axios";

import { devSettings, isDev } from "./dev";

const instance = axios.create({
    baseURL: isDev
        ? "http://localhost:4000"
        : (process.env.REACT_APP_API_URL ?? window.location.origin),
    timeout: 40000,
});

instance.interceptors.request.use((config) => {
    let token = window.localStorage.getItem("legacyToken");

    if (isDev) {
        token = devSettings.api.token;

        if (devSettings.token == "") {
            alert(
                "You are running in dev mode but did not specify a token for the client connecting to " +
                    instance.baseURL,
            );
        }
    }

    if (
        window.heatUserData &&
        window.heatUserData.nextVersion &&
        window.heatUserData.nextVersion >= 2
    ) {
        if (isDev) {
            token = devSettings.api.heatToken;
        } else {
            window.localStorage.getItem("accessToken");
        }
    }

    config.headers.Authorization = `Bearer ${token}`;

    return config;
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (isDev) {
            return Promise.reject(error);
        }

        if (error.response && error.response.status === 401) {
            window.localStorage.removeItem("legacyToken");
            window.localStorage.removeItem("accessToken");
            window.localStorage.removeItem("refreshToken");
            window.location.href = "/login?force=true";
        }

        return Promise.reject(error);
    },
);

export default instance;
